import React from 'react';
import { lowerCase } from 'lodash-es';
import {
  DownloadInvoiceContainer,
  StatusContainer,
  TableClickContainer,
} from '../styles';
import {
  statusLabels,
  employeeStatusEnum,
  programStatusEnum,
  paymentStatusEnum,
  creditTransactionsStatusEnum,
  topupsStatusEnum,
  sourceToCreditType,
  eventsAmountEnum,
  orderStatusEnum,
  reportTypeEnum,
  reportStatusEnum,
  paymentRequestStatus,
  expenseRequestStatusEnum,
  sourceDeductedTaxComponentEnum,
} from '../../constants';
import {
  checkValidExecutionDate,
  dateSortableFormat,
  employeeCountForAdhocPrograms,
  employeeTableValueForFlowType,
  formatAmountInRupees,
  formatCreditTransactionActualTopupDate,
  formatDateinDDMMMYYY,
  formatDateinDDMMMYYYAndTime,
  formatDateinDDMMMYYYAndTimeWithoutSeparator,
  formatEventsAmountValue,
  formatIDForGifting,
  formatReferenceIDForPayments,
  getCycleAmount,
  getCycleFrequency,
  getEmployeesCountFromGroups,
  getPeriodForInvoice,
  getStatusForInvoice,
  isInvoiceGenerated,
  isProgramEnded,
  isValidPaymentRequest,
  maskUptoFirstNDigits,
  maskUptoLastNDigits,
  paymentLinkForAdhocPrograms,
  payOnlineInvoice,
  statusForAdhocPrograms,
  totalAmountForAdhocProgram,
  truncateUptoNDigits,
} from '../../../../../helpers';
import ActionGroupsTable from '../../../../Employees/GroupsTable/ActionGroupsTable';
import ActionProgramsTable from '../../../../WalletPrograms/ActionProgramsTable';
import PlanDetailsBtns from '../../../../WalletPrograms/PlanDetails';
import { frequencyTypes } from '../../../../WalletPrograms/constants';
import RemoveEmployeeBtn from '../../RemoveEmployeeBtn';
import { getReportFile } from '../../../../../api/reports';
import {
  GC_PLAN,
  MEAL_PLAN,
} from '../../../../WalletPrograms/CreateProgramModal/ProgramForms/common/Components/constants';

export const programHeadColumn = [
  {
    name: 'Meal plan name',
    selector: row => row.name,
    sortable: true,
    cell: row => <PlanDetailsBtns plan={row} title={MEAL_PLAN} />,
  },
  {
    name: 'Top-up frequency',
    selector: 'cycle_type',
    sortable: true,
    cell: row => frequencyTypes[row.cycle_type],
  },
  {
    name: 'Budget/employee',
    selector: row => row.monthly_amount || row.weekly_amount,
    sortable: true,
    cell: row => getCycleAmount(row),
  },
  {
    name: 'Plan top-up cycle',
    selector: row => dateSortableFormat(row.start_date).getDate(),
    sortable: true,
    cell: row => getCycleFrequency(row),
  },
  {
    name: 'No. of employees',
    selector: row => getEmployeesCountFromGroups(row.groups_data),
    sortable: true,
    cell: row => getEmployeesCountFromGroups(row.groups_data),
  },
  // {
  //   name: 'Start date',
  //   grow: 0.6,
  //   selector: row => row.start_date,
  //   sortable: true,
  //   cell: row => formatDateWithoutTime(row.start_date),
  // },
  // {
  //   name: 'End date',
  //   grow: 0.6,
  //   selector: row => row.end_date,
  //   sortable: true,
  //   cell: row =>
  //     getFormattedEndDate(row.end_date) !== 'NA'
  //       ? formatDateWithoutTime(row.end_date)
  //       : 'NA',
  // },
  {
    name: 'Last top-up',
    selector: row => row.last_topup,
    sortable: true,
    cell: row =>
      row.last_topup && row.last_topup !== 0
        ? formatAmountInRupees(row.last_topup)
        : ' - ',
  },
  {
    name: 'Status',
    selector: row => row.program_status,
    sortable: true,
    cell: row => (
      <StatusContainer
        status={programStatusEnum[row.program_status] ?? 'default'}
      >
        {statusLabels[programStatusEnum[row.program_status] ?? 'default']}
      </StatusContainer>
    ),
  },
];

export const limitProgramsHeadColumn = [
  {
    name: 'Meal plan name',
    selector: row => row.name,
    sortable: true,
    cell: row => <PlanDetailsBtns plan={row} title={MEAL_PLAN} />,
  },
  {
    name: 'Frequency',
    selector: 'cycle_type',
    sortable: true,
    cell: row => frequencyTypes[row.cycle_type],
  },
  {
    name: 'Budget/employee',
    selector: row => row.monthly_amount || row.weekly_amount,
    sortable: true,
    cell: row => getCycleAmount(row),
  },
  {
    name: 'Plan cycle',
    selector: row => dateSortableFormat(row.start_date).getDate(),
    sortable: true,
    cell: row => getCycleFrequency(row),
  },
  {
    name: 'No. of employees',
    selector: row => getEmployeesCountFromGroups(row.groups_data),
    sortable: true,
    cell: row => getEmployeesCountFromGroups(row.groups_data),
  },
  {
    name: 'Status',
    selector: row => row.program_status,
    sortable: true,
    cell: row => (
      <StatusContainer
        status={programStatusEnum[row.program_status] ?? 'default'}
      >
        {statusLabels[programStatusEnum[row.program_status] ?? 'default']}
      </StatusContainer>
    ),
  },
  {
    name: <div style={{ marginLeft: '30px' }}> Action</div>,
    grow: 0.6,
    cell: row => <ActionProgramsTable data={row} />,
  },
];

export const fullFlexProgramHeadColumn = [
  {
    name: 'Meal plan name',
    selector: row => row.name,
    sortable: true,
    cell: row => <PlanDetailsBtns plan={row} title={MEAL_PLAN} isFullFlexEnabled />,
  },
  {
    name: 'Start date',
    selector: row => row.start_date,
    sortable: true,
    cell: row => formatDateinDDMMMYYY(row.start_date),
  },
  {
    name: 'Start Time',
    selector: (row) => row.start_time,
    sortable: true,
    cell: (row) => row.start_time,
  },
  {
    name: 'End date',
    selector: row => row.end_date,
    sortable: true,
    cell: row => row.never_ends ? 'NA' :formatDateinDDMMMYYY(row.end_date),
  },
  {
    name: 'No. of employees',
    selector: row => getEmployeesCountFromGroups(row.groups_data),
    sortable: true,
    cell: row => getEmployeesCountFromGroups(row.groups_data),
  },
  {
    name: 'Status',
    selector: row => row.program_status,
    sortable: true,
    cell: row => (
      <StatusContainer
        status={programStatusEnum[row.program_status] ?? 'default'}
      >
        {statusLabels[programStatusEnum[row.program_status] ?? 'default']}
      </StatusContainer>
    ),
  },
  {
    name: <div style={{ marginLeft: '30px' }}> Action</div>,
    grow: 0.6,
    cell: row => <ActionProgramsTable data={row} />,
  },
]

export const reportsHeadColumn = [
  {
    name: 'Report date',
    selector: row => row.created_on,
    sortable: true,
    cell: row => formatDateinDDMMMYYY(row.created_on),
  },
  {
    name: 'Report ID',
    grow: 0.8,
    selector: row => row.report_id,
    sortable: true,
    cell: row => maskUptoFirstNDigits(row.report_id, 6),
  },
  {
    name: 'Report type',
    grow: 1.4,
    selector: row => row.type,
    sortable: true,
    cell: row => statusLabels[reportTypeEnum[row.type]],
  },
  {
    name: 'Start date',
    selector: row => row.start_date,
    sortable: true,
    cell: row => formatDateinDDMMMYYY(row.start_date),
  },
  {
    name: 'End date',
    selector: row => row.end_date,
    sortable: true,
    cell: row => formatDateinDDMMMYYY(row.end_date),
  },
  {
    name: 'Status',
    selector: row => row.status,
    sortable: true,
    cell: row => (
      <StatusContainer status={reportStatusEnum[row.status]}>
        {statusLabels[reportStatusEnum[row.status]]}
      </StatusContainer>
    ),
  },
  {
    name: 'Action',
    cell: row => getReportFile(row),
  },
];

export const employeeHeadColumn = [
  {
    name: 'Email ID',
    selector: row => row.email,
    minWidth: '210px',
    sortable: true,
    cell: row => (
      <TableClickContainer
        to={{
          pathname: `/employees/employee-details/${row.email_hash}`,
        }}
      >
        {truncateUptoNDigits(row.email, 18)}
      </TableClickContainer>
    ),
  },
  {
    name: 'Added on',
    selector: row => row.created_on,
    minWidth: '125px',
    grow: 0.7,
    sortable: true,
    cell: row => formatDateinDDMMMYYY(row.created_on),
  },
  // {
  //   name: 'Employee Name',
  //   selector: row => row.name,
  //   sortable: true,
  //   cell: row => (row.name && row.name !== '' ? row.name : ' - '),
  // },
  {
    name: 'Team name',
    selector: row =>
      employeeTableValueForFlowType(row, row.group_name, row.limit_group_name),
    grow: 1,
    sortable: true,
    cell: row =>
      employeeTableValueForFlowType(row, row.group_name, row.limit_group_name),
  },
  {
    name: 'Meal plan name',
    selector: row =>
      employeeTableValueForFlowType(
        row,
        row.program_name,
        row.limit_program_name,
      ),
    grow: 1,
    sortable: true,
    cell: row =>
      employeeTableValueForFlowType(
        row,
        row.program_name,
        row.limit_program_name,
      ),
  },
  {
    name: <div style={{ paddingLeft: '5px' }}>Status</div>,
    selector: row => row.status,
    sortable: true,
    minWidth: '180px',
    cell: row => (
      <StatusContainer status={employeeStatusEnum[row.status]}>
        {statusLabels[employeeStatusEnum[row.status]]}
      </StatusContainer>
    ),
  },
  {
    name: '',
    grow: 0.2,
    cell: row =>
      row.status !== employeeStatusEnum.EXITED &&
      row.status !== employeeStatusEnum.REMOVED_EXITED ? (
        <RemoveEmployeeBtn employee={row} />
      ) : (
        ''
      ),
  },
];

export const groupHeadColumn = [
  {
    name: 'Team name',
    selector: row => row.group_name,
    sortable: true,
    cell: row => (
      <TableClickContainer
        to={`/employees/group-details/${row.group_id}`}
      >
        {row.group_name}
      </TableClickContainer>
    ),
  },
  {
    name: 'Created on',
    selector: row => row.created_on,
    sortable: true,
    cell: row => formatDateinDDMMMYYY(row.created_on),
  },
  {
    name: 'Employees',
    selector: row => row.employees,
    sortable: true,
    cell: row => row.employees ?? ' - ',
  },
  {
    name: 'Existing employees',
    selector: row => row.active_employees,
    sortable: true,
    cell: row => row.active_employees ?? ' - ',
  },
  {
    name: 'Meal plan name',
    selector: row => row.program_name,
    sortable: true,
    cell: row =>
      !row.can_plan_be_mapped && row.program_name !== ''
        ? row.program_name
        : ' - ',
  },
  {
    name: <div style={{ marginLeft: '30px' }}> Action</div>,
    grow: 0.4,
    cell: row => <ActionGroupsTable data={row} />,
  },
];

export const employeeForGroupHeadColumn = [
  {
    name: 'Email ID',
    selector: row => row.email,
    sortable: true,
    cell: row => (
      <TableClickContainer
        to={{
          pathname: `/employees/employee-details/${row.email_hash}`,
        }}
      >
        {truncateUptoNDigits(row.email, 20)}
      </TableClickContainer>
    ),
  },
  {
    name: 'Employee name',
    selector: row => row.name,
    sortable: true,
    cell: row => (row.name && row.name !== '' ? row.name : ' - '),
  },
  {
    name: 'Added on',
    selector: row => row.created_on,
    sortable: true,
    cell: row => formatDateinDDMMMYYY(row.created_on),
  },
  {
    name: <div style={{ paddingLeft: '5px' }}>Status</div>,
    selector: row => row.status,
    sortable: true,
    cell: row => (
      <StatusContainer status={employeeStatusEnum[row.status]}>
        {statusLabels[employeeStatusEnum[row.status]]}
      </StatusContainer>
    ),
  },
  {
    name: '',
    grow: 0.5,
    cell: row =>
      row.status !== employeeStatusEnum.EXITED &&
      row.status !== employeeStatusEnum.REMOVED_EXITED ? (
        <RemoveEmployeeBtn employee={row} fromGroup />
      ) : (
        ''
      ),
  },
];

export const paymentsCreditsHeadColumn = [
  {
    name: 'Date',
    selector: row => dateSortableFormat(row.created_on),
    grow: 0.8,
    sortable: true,
    cell: row => formatDateinDDMMMYYYAndTime(row.created_on),
  },
  {
    name: 'Payment type',
    selector: row => sourceToCreditType(row.source),
    grow: 0.8,
    sortable: true,
    cell: row => sourceToCreditType(row.source),
  },
  {
    name: 'Reference no.',
    selector: row => row.reference_id,
    grow: 1.3,
    sortable: true,
    cell: row => formatReferenceIDForPayments(row),
  },
  {
    name: 'Amount',
    grow: 1,
    selector: row => row.amount,
    sortable: true,
    cell: row => formatAmountInRupees(row.amount),
  },
  {
    name: 'Status',
    selector: row => row.status,
    grow: 0.8,
    sortable: true,
    cell: row => (
      <StatusContainer status={paymentStatusEnum[row.status] ?? 'default'}>
        {statusLabels[paymentStatusEnum[row.status] ?? 'default']}
      </StatusContainer>
    ),
  },
];

export const paymentsDebitsHeadColumn = [
  {
    name: 'Top-up date',
    selector: row => row.execution_date,
    grow: 0.9,
    sortable: true,
    cell: row =>
      checkValidExecutionDate(row.execution_date)
        ? formatDateinDDMMMYYY(row.execution_date)
        : ' - ',
  },
  {
    name: 'Meal plan',
    selector: row => row.program_name,
    grow: 0.75,
    sortable: true,
    cell: row => row.program_name,
  },
  {
    name: 'Amount topped-up',
    selector: row => row.disbursed_amount.value,
    sortable: true,
    grow: 0.7,
    cell: row => formatAmountInRupees(row?.disbursed_amount?.value),
  },
  {
    name: 'Amount pending',
    selector: row => row.total_amount.value - row.disbursed_amount.value,
    sortable: true,
    grow: 0.7,
    cell: row => formatEventsAmountValue(row, eventsAmountEnum.PENDING, false),
  },
  {
    name: 'Amount released',
    selector: row => row.total_amount.value - row.disbursed_amount.value,
    sortable: true,
    grow: 0.7,
    cell: row => formatEventsAmountValue(row, eventsAmountEnum.RELEASED, false),
  },
  {
    name: 'Ref. ID',
    selector: row => row.event_id,
    grow: 0.8,
    sortable: true,
    cell: row => (
      <TableClickContainer
        to={`/payments/event-details/${row.program_id}/${row.event_id}`}
      >
        {maskUptoLastNDigits(row.event_id, 6)}
      </TableClickContainer>
    ),
  },
  {
    name: <div style={{ paddingLeft: '5px' }}>Status</div>,
    selector: row => row.status,
    sortable: true,
    grow: 0.8,
    cell: row => (
      <StatusContainer status={topupsStatusEnum[row.status] ?? 'default'}>
        {statusLabels[topupsStatusEnum[row.status] ?? 'default']}
      </StatusContainer>
    ),
  },
];

export const giftingProgramHeadColumn = [
  {
    name: 'Date & time',
    grow: 0.8,
    selector: row => dateSortableFormat(row.created_on),
    sortable: true,
    cell: row => formatDateinDDMMMYYYAndTimeWithoutSeparator(row.created_on),
  },
  {
    name: 'ID',
    grow: 0.8,
    selector: row => row.program_id,
    sortable: true,
    cell: row => {
      return (
        <div style={{ display: 'flex' }}>
          <TableClickContainer
            to={`/gifting/info/${row.program_id}`}
          >
            {formatIDForGifting(row.program_id)}
          </TableClickContainer>
        </div>
      );
    },
  },
  {
    name: 'Occasion',
    selector: row => lowerCase(row?.gift_card_details?.type_name),
    sortable: true,
    grow: 1,
    cell: row => row?.gift_card_details?.type_name,
  },
  {
    name: 'Execution date',
    selector: row => dateSortableFormat(row.start_date),
    sortable: true,
    cell: row => formatDateinDDMMMYYY(row.start_date),
  },
  {
    name: 'No. of gift cards',
    grow: 0.8,
    selector: row => employeeCountForAdhocPrograms(row),
    sortable: true,
    cell: row => employeeCountForAdhocPrograms(row),
  },
  {
    name: 'Total amount',
    grow: 0.8,
    selector: row => totalAmountForAdhocProgram(row),
    sortable: true,
    cell: row => totalAmountForAdhocProgram(row),
  },
  {
    name: 'Status',
    cell: row => statusForAdhocPrograms(row),
  },
  {
    name: 'Action',
    selector: row => paymentLinkForAdhocPrograms(row),
    sortable: true,
    cell: row => {
      const paymentReqDetails = row?.payment_request;
      if (isValidPaymentRequest(paymentReqDetails) && !isProgramEnded(row)) {
        if (paymentReqDetails?.status === paymentRequestStatus.ACTIVE_PENDING) {
          return <PlanDetailsBtns plan={row} title={GC_PLAN} toStep={3} />;
        }
      }
      return ' - ';
    },
  },
];

export const giftingRecipientsHeadColumn = [
  {
    name: 'Email ID',
    selector: row => row.email,
    grow: 1.4,
    sortable: true,
    cell: row => (
      <TableClickContainer
        to={{
          pathname: `/employees/employee-details/${row.email_hash}`,
        }}
      >
        {row.email}
      </TableClickContainer>
    ),
  },
  {
    name: 'Added on',
    selector: row => row.created_on,
    minWidth: '125px',
    grow: 0.7,
    sortable: true,
    cell: row => formatDateinDDMMMYYY(row.created_on),
  },
];

export const giftingProgramRecipientsHeadColumn = [
  {
    name: 'Email',
    selector: 'email',
    sortable: true,
    cell: row => {
      return (
        <TableClickContainer
          to={{
            pathname: `/employees/employee-details/${row.employee_hash}`,
          }}
        >
          {row.email_id}
        </TableClickContainer>
      );
    },
  },
  {
    name: 'Issuance Date & Time',
    grow: 1.2,
    selector: row => formatCreditTransactionActualTopupDate(row),
    sortable: true,
    cell: row => formatCreditTransactionActualTopupDate(row),
  },
  // {
  //   name: 'Required Amount',
  //   selector: 'req_amt',
  //   grow: 0.8,
  //   sortable: true,
  //   cell: row => (row.req_amt ? `${formatAmountInRupees(row.req_amt)}` : ' - '),
  // },
  // {
  //   name: 'Disbursed Amount',
  //   selector: 'actual_amt',
  //   grow: 0.8,
  //   sortable: true,
  //   cell: row =>
  //     row.actual_amt ||
  //       creditTransactionsStatusEnum[row.status] ===
  //       creditTransactionsStatusEnum.TRANSACTION_SUCCESS ||
  //       creditTransactionsStatusEnum[row.status] ===
  //       creditTransactionsStatusEnum.TRANSACTION_FAILED ||
  //       creditTransactionsStatusEnum[row.status] ===
  //       creditTransactionsStatusEnum.TRANSACTION_EXPIRED_FAILED
  //       ? `${formatAmountInRupees(row.actual_amt)}`
  //       : ' - ',
  // },
  {
    name: 'Status',
    selector: 'status',
    sortable: true,
    cell: row => {
      // keeping 2 status for now
      let status = 'PROCESSING_IN_PROGRESS';
      if (row.status === creditTransactionsStatusEnum.TRANSACTION_SUCCESS) {
        status = 'GC_COMPLETED_ENDED';
      }
      return (
        <StatusContainer status={status}>
          {statusLabels[status]}
        </StatusContainer>
      );
    },
  },
];

export const upcomingTopupsHeadColumns = [
  {
    name: 'Top-up date',
    selector: row => row.scheduled_date,
    sortable: true,
    cell: row => formatDateinDDMMMYYY(row.scheduled_date),
  },
  {
    name: 'Meal plan',
    selector: row => row.program_name,
    sortable: true,
    cell: row => row.program_name,
  },
  {
    name: 'Number of employees',
    selector: row => row.no_of_employees,
    sortable: true,
    cell: row => row.no_of_employees ?? '-',
  },
  // {
  //   name: 'Event type',
  //   selector: row => row.event_type,
  //   sortable: true,
  //   cell: row =>
  //     statusLabels[topupEventTypeStatusEnum[row.event_type] ?? 'default'],
  // },
  {
    name: 'Amount required',
    selector: row => row.total_amount.value,
    sortable: true,
    cell: row =>
      row?.total_amount?.value
        ? formatAmountInRupees(row?.total_amount?.value)
        : ' - ',
  },
  {
    name: <div style={{ paddingLeft: '5px' }}>Status</div>,
    selector: row => row.status,
    sortable: true,
    cell: row => (
      <StatusContainer status={topupsStatusEnum[row.status] ?? 'default'}>
        {statusLabels[topupsStatusEnum[row.status] ?? 'default']}
      </StatusContainer>
    ),
  },
];

export const previousTopupsHeadColumns = [
  {
    name: 'Planned date',
    selector: row => row.scheduled_date,
    grow: 0.6,
    sortable: true,
    cell: row => formatDateinDDMMMYYY(row.scheduled_date),
  },
  {
    name: 'Meal plan',
    selector: row => row.program_name,
    grow: 0.75,
    sortable: true,
    cell: row => row.program_name,
  },
  {
    name: 'No. of employees',
    selector: row => row.no_of_employees,
    grow: 0.7,
    sortable: true,
    cell: row => row.no_of_employees ?? '-',
  },
  // {
  //   name: 'Event type',
  //   selector: row => row.event_type,
  //   grow: 0.75,
  //   sortable: true,
  //   cell: row =>
  //     statusLabels[topupEventTypeStatusEnum[row.event_type] ?? 'default'],
  // },
  {
    name: 'Actual top-up date',
    selector: row => row.execution_date,
    grow: 0.9,
    sortable: true,
    cell: row =>
      checkValidExecutionDate(row.execution_date)
        ? formatDateinDDMMMYYY(row.execution_date)
        : ' - ',
  },
  {
    name: 'Amount pending',
    selector: row => row.total_amount.value - row.disbursed_amount.value,
    sortable: true,
    grow: 0.7,
    cell: row => formatEventsAmountValue(row, eventsAmountEnum.PENDING, false),
  },
  {
    name: 'Amount topped-up',
    selector: row => row.disbursed_amount.value,
    sortable: true,
    grow: 0.9,
    cell: row => formatAmountInRupees(row?.disbursed_amount?.value),
  },
  {
    name: 'Ref. ID',
    selector: row => row.event_id,
    grow: 0.8,
    sortable: true,
    cell: row => (
      <TableClickContainer
        to={`/home/event-details/${row.program_id}/${row.event_id}`}
      >
        {maskUptoLastNDigits(row.event_id, 6)}
      </TableClickContainer>
    ),
  },
  {
    name: <div style={{ paddingLeft: '5px' }}>Status</div>,
    selector: row => row.status,
    sortable: true,
    grow: 0.8,
    cell: row => (
      <StatusContainer status={topupsStatusEnum[row.status] ?? 'default'}>
        {statusLabels[topupsStatusEnum[row.status] ?? 'default']}
      </StatusContainer>
    ),
  },
];

export const consumptionDetailsHeadColumns = [
  {
    name: 'Date & Time',
    grow: 1,
    minWidth: '180px',
    selector: row => row.created_on,
    sortable: true,
    cell: row => formatDateinDDMMMYYYAndTime(row.created_on),
  },
  {
    name: 'Email ID',
    selector: row => row.employee_email,
    sortable: true,
    grow: 1,
    minWidth: '200px',
    cell: row => (
      <TableClickContainer
        to={{
          pathname: `/home/employee-details/${row.employee_hash}`,
        }}
      >
        {truncateUptoNDigits(row.employee_email, 18)}
      </TableClickContainer>
    ),
  },
  {
    name: 'Order ID',
    grow: 1,
    minWidth: '200px',
    selector: row => row.order_id,
    sortable: true,
    cell: row => row.order_id ?? '-',
  },
  {
    name: 'Paid using Enterprise budget',
    grow: 1,
    minWidth: '150px',
    selector: row => row.amount,
    sortable: true,
    cell: row => (row?.amount ? formatAmountInRupees(row?.amount) : ' - '),
  },
  {
    name: 'Refunded to Enterprise budget',
    grow: 1,
    minWidth: '180px',
    selector: row => row.refund_amount,
    sortable: true,
    cell: row =>
      row?.refund_amount ? formatAmountInRupees(row?.refund_amount) : ' - ',
  },
  {
    name: 'Status',
    selector: row => row.status,
    grow: 1,
    minWidth: '180px',
    sortable: true,
    cell: row => (
      <StatusContainer status={orderStatusEnum[row.status] ?? 'default'}>
        {statusLabels[orderStatusEnum[row.status] ?? 'default']}
      </StatusContainer>
    ),
  },
];

export const orderExpenseDetailsHeadColumns = [
  {
    name: 'Expense Request Status',
    selector: row => row.order_expense_request?.status,
    grow: 1,
    minWidth: '180px',
    sortable: true,
    cell: row => (
      <StatusContainer
        status={
          expenseRequestStatusEnum[(row.order_expense_request?.status)] ??
          'default'
        }
      >
        {
          statusLabels[
            expenseRequestStatusEnum[(row.order_expense_request?.status)] ??
              'default'
          ]
        }
      </StatusContainer>
    ),
  },
];

export const employeeConsumptionsHeadColumns = [
  {
    name: 'Date & Time',
    grow: 1,
    minWidth: '180px',
    selector: row => row.created_on,
    sortable: true,
    cell: row => formatDateinDDMMMYYYAndTime(row.created_on),
  },
  {
    name: 'Order ID',
    grow: 1,
    minWidth: '200px',
    selector: row => row.order_id,
    sortable: true,
    cell: row => row.order_id ?? '-',
  },
  {
    name: 'Paid by limit',
    grow: 1,
    minWidth: '150px',
    selector: row => row.amount,
    sortable: true,
    cell: row => (row?.amount ? formatAmountInRupees(row?.amount) : ' - '),
  },
  {
    name: 'Refunded to limit',
    grow: 1,
    minWidth: '180px',
    selector: row => row.refund_amount,
    sortable: true,
    cell: row =>
      row?.refund_amount ? formatAmountInRupees(row?.refund_amount) : ' - ',
  },
  {
    name: 'Status',
    selector: row => row.status,
    grow: 1,
    minWidth: '180px',
    sortable: true,
    cell: row => (
      <StatusContainer status={orderStatusEnum[row.status] ?? 'default'}>
        {statusLabels[orderStatusEnum[row.status] ?? 'default']}
      </StatusContainer>
    ),
  },
];

export const getInvoicesHeadColumn = shouldShowTDSField => {
  const invoicesHeadColumn = [
    {
      name: 'Period',
      selector: row => row.start_date,
      grow: 1,
      minWidth: '130px',
      sortable: true,
      cell: row => (
        <DownloadInvoiceContainer>
          <TableClickContainer
            to={{
              pathname: `/payments/invoice/details/${row.start_date}/${
                row.end_date
              }`,
            }}
          >
            {getPeriodForInvoice(row.start_date, true)}
          </TableClickContainer>
        </DownloadInvoiceContainer>
      ),
    },
    {
      name: 'Billed amount',
      selector: row => row.billed_amount,
      sortable: true,
      grow: 1,
      minWidth: '130px',
      cell: row =>
        row?.billed_amount ? formatAmountInRupees(row?.billed_amount) : ' - ',
    },
  ];

  if (shouldShowTDSField) {
    invoicesHeadColumn.push({
      name: 'TDS',
      selector: row => row.tds_details,
      sortable: false,
      grow: 1,
      minWidth: '180px',
      cell: row => {
        const appliedPercentage = row?.tds_details?.applied_percentage ?? 0;
        const component = row?.tds_details?.component ?? 0;
        if (appliedPercentage === 0 || component === 0) {
          return ' - ';
        }
        let componentMessage = '';
        switch (component) {
          case sourceDeductedTaxComponentEnum.PLATFORM_FEE:
            componentMessage = 'Platform Fee';
            break;
          case sourceDeductedTaxComponentEnum.INVOICE_AMOUNT:
            componentMessage = 'Full Amount';
            break;
          default:
            componentMessage = '';
        }
        return `${appliedPercentage}% on ${componentMessage}`;
      },
    });
  }

  invoicesHeadColumn.push(
    ...[
      {
        name: 'Amount payable',
        selector: row => row.payable_amount,
        sortable: true,
        grow: 1,
        minWidth: '130px',
        cell: row =>
          row?.payable_amount
            ? formatAmountInRupees(row?.payable_amount)
            : ' - ',
      },
      {
        name: 'Amount paid',
        selector: row => row.paid_amount,
        sortable: true,
        grow: 1,
        minWidth: '130px',
        cell: row =>
          row?.paid_amount ? formatAmountInRupees(row?.paid_amount) : ' - ',
      },
      {
        name: 'Amount pending',
        selector: row => row.pending_amount,
        sortable: true,
        grow: 1,
        minWidth: '130px',
        cell: row =>
          row?.pending_amount
            ? formatAmountInRupees(row?.pending_amount)
            : ' - ',
      },
      {
        name: 'Status',
        selector: row => row.status,
        sortable: true,
        grow: 1,
        minWidth: '150px',
        cell: row =>
          isInvoiceGenerated(row.status) ? getStatusForInvoice(row) : ' - ',
      },
      {
        name: <div style={{ marginLeft: '20px' }}> Action</div>,
        selector: row => row.status,
        sortable: true,
        grow: 1,
        minWidth: '150px',
        cell: row => payOnlineInvoice(row),
      },
    ],
  );
  return invoicesHeadColumn;
};

export const creditTransactionsHeadColumn = [
  {
    name: 'Employee email ID',
    selector: 'email_id',
    sortable: true,
    cell: row => (
      <TableClickContainer
        to={{
          pathname: `/employees/employee-details/${row.employee_hash}`,
        }}
      >
        {row.email_id}
      </TableClickContainer>
    ),
  },
  {
    name: 'Actual top-up date',
    selector: row => dateSortableFormat(row.created_on),
    sortable: true,
    cell: row => formatDateinDDMMMYYY(row.created_on),
  },
  {
    name: 'Amount topped-up',
    selector: 'actual_amt',
    sortable: true,
    cell: row =>
      row.actual_amt ||
      creditTransactionsStatusEnum[row.status] ===
        creditTransactionsStatusEnum.SUCCESS ||
      creditTransactionsStatusEnum[row.status] ===
        creditTransactionsStatusEnum.FAILED ||
      creditTransactionsStatusEnum[row.status] ===
        creditTransactionsStatusEnum.EXPIRED
        ? `${formatAmountInRupees(row.actual_amt)}`
        : ' - ',
  },
  {
    name: 'Status',
    selector: 'status',
    sortable: true,
    cell: row => (
      <StatusContainer status={creditTransactionsStatusEnum[row.status]}>
        {statusLabels[creditTransactionsStatusEnum[row.status]]}
      </StatusContainer>
    ),
  },
];

export const creditTransactionsForEmployeeHeadColumn = [
  {
    name: 'Meal plan',
    selector: row => row.program_name,
    sortable: true,
    cell: row => row.program_name,
  },
  {
    name: 'Created on',
    selector: row => row.created_on,
    sortable: true,
    cell: row => formatDateinDDMMMYYY(row.created_on),
  },
  {
    name: 'Amount required',
    selector: row => row.req_amt,
    grow: 0.8,
    sortable: true,
    cell: row => (row.req_amt ? formatAmountInRupees(row.req_amt) : ' - '),
  },
  {
    name: 'Actual amount',
    selector: row => row.actual_amt,
    grow: 0.8,
    sortable: true,
    cell: row =>
      row.actual_amt ? formatAmountInRupees(row.actual_amt) : ' - ',
  },
  {
    name: <div style={{ paddingLeft: '5px' }}>Status</div>,
    selector: row => row.status,
    sortable: true,
    cell: row => (
      <StatusContainer status={creditTransactionsStatusEnum[row.status]}>
        {statusLabels[creditTransactionsStatusEnum[row.status]]}
      </StatusContainer>
    ),
  },
];
